module.exports = __webpack_public_path__ + "media/images/triangle_bullet-c7a64147afafccd3795f31b713568c07.svg";